export default Object.freeze({
  name: 'development',
  prod: false,
  'storage-prefix': 'b5a-pos-test',
  api: {
    baseURL: process.env.REACT_APP_API_BASEURL,
  },
});
